/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData, CUSTOM_COMMUNITY_BUTTONS } from "./types"

const saveoursound: CommunityData = {
  code: "saveoursound",
  inviteCode: "saveoursound",
  name: "Save our Sound",
  thumbnail: "/assets/customizations/saveoursound/thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/saveoursound`,
  socials: {},
  styles: {
    global: {
      counterColor: "#F4FF00",
      logo: {
        src: "/assets/customizations/saveoursound/logo2.png",
        styles: "w-[68px] sm:w-[68px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/saveoursound/logo.png",
        styles: "w-[110px] sm:w-[128px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[4px] border-[#000000]",
      bgColor: "#000000",
      asideBg: "#F4FF00",
      asideStyles: "border-r-[#000000] border-r",
      contentBg: "#F4FF00",
      bgDesktop: "/assets/customizations/saveoursound/bg.png",
      bgMobile: "/assets/customizations/saveoursound/bg.png",
      mainFont: "font-['HelveticaNeue']",
      customPrimaryButton: CUSTOM_COMMUNITY_BUTTONS.SAVE_OUR_SOUND,
      primaryButton:
        "flex justify-center items-center uppercase !text-[18px] pt-1 !h-[64px] bg-[#000000] !text-[#F4FF00] sm:px-[40px] cursor-pointer font-bold",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#000000",
      separator: "border-t-[#000000] border-t",
      item: "text-[20px] font-['HelveticaNeueCondensedBold'] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-1 !pt-5",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "text-[40px] leading-[48px] font-['HelveticaNeueCondensedBold']",
      announcements: {
        lg: {
          title:
            "text-[15px] leading-[15px] mt-2 !text-[#F4FF00] font-['HelveticaNeueCondensedBold']",
          subtitle:
            "font-medium text-[12px] leading-[10px] bg-[#F4FF00] !text-[#000000] h-[23px] flex items-center uppercase",
        },
        sm: {
          title:
            "text-[15px] leading-[15px] mt-2 !text-[#F4FF00] font-['HelveticaNeueCondensedBold']",
          subtitle:
            "font-medium text-[12px] leading-[10px] bg-[#F4FF00] !text-[#000000] h-[23px] flex items-center uppercase",
        },
      },
      event: {
        title: "text-[20px] one-line-truncate font-['HelveticaNeueCondensedBold']",
        subtitle: "font-medium uppercase text-[12px] leading-5",
      },
      shop: {
        title: "text-[20px] font-['HelveticaNeueCondensedBold']",
        text: "font-medium uppercase text-[12px] leading-5",
        customShopImage: "/assets/customizations/saveoursound/shop.png",
      },
    },
    announcements: {
      created: "font-medium uppercase text-[12px]",
      emptyOrLoadingState: "text-[18px] mb-[10px] text-[#000000] font-bold",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[40px] font-['HelveticaNeueCondensedBold']",
      title: "text-[20px] font-['HelveticaNeueCondensedBold']",
      description: "font-medium uppercase text-[12px]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      created: "font-medium uppercase text-[12px]",
      emptyOrLoadingState: "text-[18px] mb-[10px] text-[#000000] font-bold",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[20px] font-['HelveticaNeueCondensedBold']",
      description: "font-medium uppercase text-[12px]",
      commentIconColor: "",
      likeIconColor: "",
    },
    events: {
      sectionHeader: "text-[20px] font-['HelveticaNeueCondensedBold']",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[40px] font-['HelveticaNeueCondensedBold']",
      title: "text-[20px] font-['HelveticaNeueCondensedBold']",
      emptyOrLoadingState: "",
      duration: "mb-4 font-medium text-[12px] uppercase",
      address: "text-[12px] uppercase",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-black",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[18px] mb-[10px] text-[#000000] font-bold",
      header: "text-[40px] font-['HelveticaNeueCondensedBold'] !mt-0",
      sectionTitle: "text-[20px] font-['HelveticaNeueCondensedBold']",
      sectionSubtitle: "font-medium uppercase text-[12px]",
      text: "font-medium uppercase text-[12px]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#000000]",
      map: {
        pin: "#F4FF00",
        border: "mb-2 border-[4px] border-[#000000] overflow-hidden",
        pinColor: "#232734",
        strokeColor: "#F4FF00",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "text-[40px] font-['HelveticaNeueCondensedBold']",
        subtitle: "font-medium uppercase text-[12px]",
      },
      ticket: {
        title: "text-[20px] font-['HelveticaNeueCondensedBold']",
        description: "font-medium uppercase text-[12px]",
        text: "font-medium uppercase text-[12px]",
        price: "text-[20px] font-['HelveticaNeueCondensedBold']",
        counterContainer: "bg-[#000000] !border-[#000000]",
        quantity: "text-[20px] text-[#F4FF00] font-['HelveticaNeueCondensedBold']",
      },
      separator: "sm:my-8 my-6 border-b-[#000000] border-b-[1px]",
    },
    shop: {},
    linktree: {
      container:
        "font-['HelveticaNeue'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#F4FF00] p-[64px]",
      bgDesktop: "/assets/customizations/saveoursound/linktree-bg.png",
      bgMobile: "/assets/customizations/saveoursound/linktree-bg.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#000000]",
        name: "text-[40px] mt-2 font-['HelveticaNeueCondensedBold']",
        location: "text-[12px] uppercase mb-2 font-medium",
        description: "text-[12px] leading-[17px] text-center mb-4 font-medium uppercase",
        socialMediaIconColor: "#000000",
        button:
          "flex justify-center items-center text-[12px] h-[30px] bg-[#000000] text-[#F4FF00] px-4 cursor-pointer font-bold",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] text-[#F4FF00] text-center sm:w-[500px] w-[95vw] px-4 flex bg-[#000000] items-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#000000] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[14px] uppercase text-[#F4FF00] text-center",
          text: "text-[11px] text-[#F4FF00] uppercase",
          button:
            "flex justify-center items-center text-[12px] h-[30px] bg-[#F4FF00] mt-4 px-4 cursor-pointer font-bold",
        },
        header: "text-[40px] mb-[10px] text-center font-['HelveticaNeueCondensedBold'] w-screen",
        container: "gap-4 flex flex-col items-center",
        collapsedEvent: {
          container:
            "h-[64px] bg-[#000000] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          duration: "text-[12px] text-[#F4FF00] uppercase mt-[-8px]",
          name: "text-[20px] leading-[22px] mb-1 one-line-truncate text-[#F4FF00] font-bold sm:w-[390px] w-[65vw]",
          plusIconColor: "#F4FF00",
          media: "overflow-hidden m-2",
        },
        event: {
          container: "overflow-hidden bg-[#000000] sm:w-[500px] w-[95vw]",
          name: "text-[20px] leading-[22px] mb-1 text-[#F4FF00] font-bold sm:w-[390px] w-[65vw]",
          startDate:
            "!w-[64px] h-[64px] bg-[#F4FF00] flex flex-col justify-center items-center gap-1 font-bold",
          duration: "text-[12px] text-[#F4FF00] uppercase",
          location: "text-[12px] text-[#F4FF00] uppercase mb-4",
          button:
            "flex justify-center items-center text-[12px] h-[30px] bg-[#F4FF00] w-[95px] px-4 cursor-pointer font-bold",
          product: {
            container:
              "h-[71px] border-t border-t-[#F4FF00] px-4 items-center flex justify-between",
            name: "text-[20px] leading-[22px] mb-1 text-[#F4FF00] font-bold one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#F4FF00] text-[12px] uppercase",
            status: "text-[#F4FF00] text-[12px] uppercase",
            link: "text-[#F4FF00] text-[12px] uppercase",
            button:
              "flex justify-center items-center text-[12px] h-[30px] bg-[#F4FF00] px-4 cursor-pointer font-bold",
          },
        },
        seeAllEvents:
          "uppercase underline text-[12px] font-medium text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] h-[56px] text-[#F4FF00] text-center sm:w-[500px] w-[95vw] px-4 flex bg-[#000000] items-center",
        header: "text-[40px] mb-[10px] text-center font-['HelveticaNeueCondensedBold']",
        oneNews: {
          container:
            "pr-2 overflow-hidden bg-[#000000] h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          name: "text-[20px] leading-[22px] mb-1 one-line-truncate text-[#F4FF00] font-bold sm:w-[390px] w-[65vw]",
          triangleIconColor: "#F4FF00",
          created: "text-[#F4FF00] text-[12px] uppercase mt-[-7px]",
          media: "overflow-hidden m-2",
        },
        seeAllNews:
          "uppercase underline text-[12px] font-medium text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[32px] h-[56px] text-[#F4FF00] text-center sm:w-[500px] w-[95vw] px-4 flex bg-[#000000] items-center",
        header: "text-[40px] mb-[10px] text-center font-['HelveticaNeueCondensedBold']",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000]",
          name: "text-[20px] leading-[22px] mb-1 mt-[8px] one-line-truncate text-[#F4FF00] font-bold sm:w-[390px] w-[65vw]",
          triangleIconColor: "#F4FF00",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#F4FF00] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "uppercase font-mono text-[11px] font-bold text-[#000000]",
      },
    },
  },
}

export default saveoursound
